import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_RESIDENTIAL_LETTER_FOR_ILA_Mapper extends BaseFormMapper<RBC_RESIDENTIAL_LETTER_FOR_ILA> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_RESIDENTIAL_LETTER_FOR_ILA,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_RESIDENTIAL_LETTER_FOR_ILA);

		return _formData;
	}

	MapValues(): Partial<RBC_RESIDENTIAL_LETTER_FOR_ILA> {
		return {};
	}
}

const Mappings: RBC_RESIDENTIAL_LETTER_FOR_ILA = {
	signature1: 'signature1',
	solicitorName2: 'SolicitorNotary Name Print',
	address: 'lawFirmNameAddressTelephone',
	signature2: 'signature2',
	solicitorName: 'solicitorName',
	date: 'Date',
};

export interface RBC_RESIDENTIAL_LETTER_FOR_ILA {
	date: string;
	signature1: string;
	solicitorName: string;
	signature2: string;
	solicitorName2: string;
	address: string;
}
